import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import Table from "@components/Table";

import { Box, Container } from "@mui/material";
import { PagesID } from "@utils/utilsConfigurations";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import ButtonBackPage from "@components/ButtonBackPage";
import BackgroundImageCst from "@components/BackgroundImageCst";
import { useParams } from "react-router-dom";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { downloadFile, ServicesURL } from "@utils/utilsApi";
import { useAuth } from "@context/auth";
import { useFilters } from "@context/filters";
import CustomTopToolbar from "@components/Table/components/CustomTopToolbar";
import FormLoadingStateCst from "@components/FormLoadingStateCst";
import { ListLeaderboardPosition } from "../types";
import { ActionsType } from "src/interfaces/Common";
import CustomRowAction from "@components/Table/components/CustomRowAction";
import DownloadIcon from "@mui/icons-material/Download";

const LeaderboardClusterUsers: React.FC<{ page: PagesID }> = ({ page }) => {
  const { id, initiativeId, clusterId } = useParams();
  const { user } = useAuth();
  const { filters } = useFilters();
  const filterId = `${user?.id_user}_${page + initiativeId}${clusterId}`;

  const { columns, actionsTopToolbar, actionForRow, dataTable, isLoading } =
    useFetchTable(
      ServicesURL.getLeaderboardClusterRanking
        .replace(":corporateId", id ?? "1")
        .replace(":initiativeId", initiativeId ?? "")
        .replace(":clusterId", clusterId ?? ""),
      PagesID["corporate.initiative.leaderboard-cluster.users"],
      filters[filterId],
    );

  const { t } = useTranslation(["leaderboard-cluster-page"]);

  const customRenderTopToolbar = ({
    table,
  }: {
    table: any;
  }): React.ReactNode => {
    return columns ? (
      <CustomTopToolbar
        id={`${page + initiativeId}${clusterId}`}
        key={`custom_top_toolbar_${page}`}
        columns={columns
          .filter((column) => (column as any)["hasFilter"])
          .map((column) => ({
            ...column,
            visibility: true,
            visibilityInTable: true,
          }))}
        configurationTopToolbar={actionsTopToolbar}
        table={table}
        hiddenFilters={false}
        resetFormFilters={undefined}
        setHideHeader={undefined}
        counterElements={false}
        onToolbarChange={() => {}}
        modalTitle={undefined}
        noSummarySelected={undefined}
        filtersException={undefined}
        enableFullScreenToggle={false}
      />
    ) : (
      <></>
    );
  };

  const actionsRow: ActionsType[] = React.useMemo(() => {
    return actionForRow?.map((action: any) => {
      switch (action.type) {
        case "button": {
          return {
            ...action,
            callBack: (row: { id: string }) => {
              console.info(row.id);
              downloadFile(
                ServicesURL.getLeaderboardReport
                  .replace(":corporateId", id ? id : "1")
                  .replace(":initiativeId", initiativeId ? initiativeId : "")
                  .replace(":clusterId", clusterId ? clusterId : "")
                  .replace(":userId", row.id),
                false,
                `leaderboard report ${row.id}.csv`,
                { Accept: "text/csv" },
              );
            },
            getIcon: (row: any) => {
              return <DownloadIcon color={"primary"} />;
            },
          };
        }
        default:
          return action;
      }
    });
  }, [actionForRow]);

  const customRenderRowActions = ({ row }: { row: any }): React.ReactNode => {
    let configRowNew: ActionsType[] = actionsRow;

    return [
      <CustomRowAction
        key={row.id}
        row={row}
        configurationActionForRow={configRowNew}
      />,
    ];
  };

  const dataMapper = (dataTableObj?: ListLeaderboardPosition) => {
    return (
      dataTableObj?.leaderboards.map((pos) => {
        return {
          ranking: pos.ranking,
          id: pos.studentEid,
          name: pos.user?.name,
          surname: pos.user?.surname,
          group_id: pos.user?.groupId?.join(","),
          group_name: pos.user?.groupName?.join(","),
          score: pos.totalScore,
        };
      }) ?? []
    );
  };

  return (
    <>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-community.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst title={t("users.hero-title")} description={""} />
        <ButtonBackPage />
        <Box
          sx={{
            mt: "25px",
          }}
        >
          {isLoading ? (
            <FormLoadingStateCst />
          ) : (
            <Table
              id={`${page + initiativeId}${clusterId}`}
              data={dataMapper(dataTable)}
              columns={columns || []}
              configurationTopToolbar={actionsTopToolbar}
              totalPages={dataTable?.metadata?.totalElements}
              renderTopToolbar={customRenderTopToolbar}
              enableRowActions={true}
              renderRowActions={customRenderRowActions}
            />
          )}
        </Box>
      </Container>
    </>
  );
};

export default LeaderboardClusterUsers;
